"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Growth = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Growth"));

// Generated by script, don't edit it please.
var Growth = (0, _createSvgIcon["default"])({
  as: _Growth["default"],
  ariaLabel: 'growth',
  category: 'application',
  displayName: 'Growth'
});
var _default = Growth;
exports["default"] = _default;
module.exports = exports.default;